// Legacy secret login alias — also works at /admin/login
export const ADMIN_LOGIN_PATH =
  process.env.REACT_APP_ADMIN_LOGIN_PATH || '/admin/login';
